export default __webpack_public_path__ + "static/media/camera.32df05b3.jpeg";